import { createFileRoute } from "@tanstack/react-router";
import { SITE } from "@/lib/site";
import { seoTitle, seoDescription } from "@/lib/seo-meta";

const TITLE = seoTitle("Política de Privacidade | Empresa Brasil Online");
const DESC = seoDescription(
  "Política de Privacidade da Empresa Brasil Online: como coletamos, usamos, armazenamos e protegemos seus dados pessoais, conforme a LGPD do Brasil.",
);

export const Route = createFileRoute("/politica-de-privacidade")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { name: "robots", content: "index,follow" },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:url", content: "/politica-de-privacidade" },
    ],
    links: [{ rel: "canonical", href: `${SITE.baseUrl}/politica-de-privacidade` }],
  }),
  component: PrivacidadePage,
});

function PrivacidadePage() {
  const updated = "9 de julho de 2026";
  return (
    <article className="container-svg max-w-3xl py-16">
      <header className="mb-10">
        <p className="text-xs uppercase tracking-widest text-primary font-semibold">Documento legal · LGPD</p>
        <h1 className="mt-2 text-4xl font-semibold">Política de Privacidade</h1>
        <p className="mt-3 text-sm text-muted-foreground">Última atualização: {updated}</p>
      </header>

      <div className="prose max-w-none space-y-6 text-[15px] leading-relaxed text-muted-foreground">
        <section>
          <h2 className="text-foreground">1. Quem somos</h2>
          <p>A {SITE.name} é uma plataforma editorial independente e é a controladora dos dados pessoais coletados por este site, nos termos da Lei Geral de Proteção de Dados (Lei nº 13.709/2018 — LGPD).</p>
        </section>
        <section>
          <h2 className="text-foreground">2. Dados que coletamos</h2>
          <ul className="list-disc pl-6">
            <li><strong>Dados de contato fornecidos voluntariamente:</strong> nome, e-mail e mensagens enviadas pelo formulário.</li>
            <li><strong>Dados de navegação:</strong> endereço IP, tipo de dispositivo, navegador, páginas visitadas, coletados por cookies e ferramentas de analytics.</li>
            <li><strong>Dados de cadastro:</strong> credenciais dos autores e editores do redação autenticados.</li>
          </ul>
        </section>
        <section>
          <h2 className="text-foreground">3. Finalidades</h2>
          <ul className="list-disc pl-6">
            <li>Responder a contatos, sugestões e denúncias;</li>
            <li>Medir e melhorar a experiência de leitura do site;</li>
            <li>Cumprir obrigações legais;</li>
            <li>Enviar newsletter (mediante consentimento).</li>
          </ul>
        </section>
        <section>
          <h2 className="text-foreground">4. Links de parceiros</h2>
          <p>Reviews e comparativos podem conter links de parceiros comerciais claramente identificados. Ao clicar, você é redirecionado para o site do parceiro, que pode coletar dados próprios sob políticas que não controlamos.</p>
        </section>
        <section>
          <h2 className="text-foreground">5. Cookies</h2>
          <p>Utilizamos cookies próprios e de terceiros (Google Analytics) para métricas e funcionalidades. Você pode desativar cookies no seu navegador.</p>
        </section>
        <section>
          <h2 className="text-foreground">6. Compartilhamento de dados</h2>
          <p>Não vendemos seus dados. Compartilhamos apenas com fornecedores essenciais (hospedagem, e-mail, analytics) e quando exigido por autoridade competente.</p>
        </section>
        <section>
          <h2 className="text-foreground">7. Seus direitos</h2>
          <p>Você pode solicitar acesso, correção ou exclusão dos seus dados a qualquer momento escrevendo para <a className="text-primary underline font-semibold" href={`mailto:${SITE.email}`}>{SITE.email}</a>.</p>
        </section>
        <section>
          <h2 className="text-foreground">8. Atualizações</h2>
          <p>Esta Política pode ser atualizada periodicamente. A data da última revisão estará sempre no topo.</p>
        </section>
      </div>
    </article>
  );
}
